// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"17e02863","261":"01c8de36","385":"5d04f9f4","464":"72d8bdeb","571":"929a2193","585":"88498794","632":"9bf7bfff","766":"bc8c2d2b","906":"8a68c5c6","921":"b846cd22"}[chunkId] + ".chunk.js";
};